import { render } from "./WeddingHero.vue?vue&type=template&id=34640026&scoped=true"
import script from "./WeddingHero.vue?vue&type=script&lang=js"
export * from "./WeddingHero.vue?vue&type=script&lang=js"

import "./WeddingHero.vue?vue&type=style&index=0&id=34640026&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34640026"]])

export default __exports__